/**
 * This is the entry file for webpack/config/front.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();


// Cookies
import '/node_modules/vanilla-cookieconsent/dist/cookieconsent.js';

// Datetime picker
import '/node_modules/jquery-datetimepicker/build/jquery.datetimepicker.full.min.js';


// Application
import '/webpack/assets/js/front/flashMessenger.js';
import '/webpack/assets/js/front/netteFormsExtension.js';
import '/webpack/assets/js/date.js';
import '/webpack/assets/js/front/general.js';
import '/webpack/assets/js/front/fullcalendar.js';
